import { render, staticRenderFns } from "./ScegliSezione.vue?vue&type=template&id=d294ed8e"
import script from "./ScegliSezione.vue?vue&type=script&lang=js"
export * from "./ScegliSezione.vue?vue&type=script&lang=js"
import style0 from "./ScegliSezione.vue?vue&type=style&index=0&id=d294ed8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports